export default __webpack_public_path__ + "775b0ad4036e05f25346268a2f26b13e.svg";